import { ICardProps } from '@/entities/Card'

export interface IPaymentState {
  cards: ICardProps[] | null
  error: unknown | null
}

export const state = (): IPaymentState => ({
  cards: null,
  error: null
})

export default state
